import { useQuery } from '@tanstack/react-query';
import {
  apiPollContactSearch,
  type ContactSearchResponse,
  type ActurisContact,
} from 'api/quote-marketplace';

const POLL_INTERVAL = 2000;

interface UseRecentContactsOptions {
  enabled?: boolean;
}

interface UseRecentContactsResult {
  contacts: ActurisContact[];
  count: number;
  status: ContactSearchResponse['status'];
  error: string | null;
  isLoading: boolean;
}

export const useRecentContacts = ({
  enabled = true,
}: UseRecentContactsOptions = {}): UseRecentContactsResult => {
  const query = useQuery({
    queryKey: ['recent-contacts'],
    queryFn: () => apiPollContactSearch(''),
    enabled,
    refetchInterval: (query) => {
      const data = query.state.data;
      if (data?.status === 'pending') {
        return POLL_INTERVAL;
      }
      return false;
    },
  });

  const data = query.data;
  const isLoading =
    query.isLoading || query.isFetching || data?.status === 'pending';

  return {
    contacts: data?.results || [],
    count: data?.count || 0,
    status: data?.status || 'idle',
    error: data?.error || null,
    isLoading,
  };
};
